import styled from '@emotion/styled';

export const Container = styled.div`
  background-color: #094967;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 3px;
  padding-top: 10em;
  padding-bottom: 10em;
`;

export const Form = styled.div`
  padding-top: 20px;
`;
export const Heading = styled.h1`
  @import url('https://fonts.googleapis.com/css?family=Bitter');
  color: white;
  font-family: 'Bitter';
  font-weight: 500;
  font-size: 60px;
  line-height: 72px;
`;

export const Image = styled.div`
  img {
    max-width: 455px;
  }
`;
